// src/stores/auth.js
import { defineStore } from 'pinia'
import AuthService from '../services/auth.service'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: AuthService.getToken() || null,
    isAuthenticated: !!AuthService.getToken(),
    userType: null
  }),

  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    isLoggedIn: (state) => state.isAuthenticated,
    // Getters para verificar o tipo de usuário
    isAdmin: (state) => state.userType === 'admin',
    isCompany: (state) => state.userType === 'client',
    // Novo getter para agências
    isAgency: (state) => state.userType === 'agency'
  },

  actions: {
    setToken(token) {
      this.token = token
      AuthService.setToken(token)
      this.isAuthenticated = true
    },

    setUser(user) {
      this.user = user
      this.userType = user.userType
      this.isAuthenticated = true
    },

    clearAuth() {
      this.user = null
      this.token = null
      this.userType = null
      this.isAuthenticated = false
      AuthService.clearToken()
    },

    async login(credentials) {
      try {
        console.log("Dentro de login store auth.js", credentials.username, credentials.password)
        const response = await AuthService.login(credentials.username, credentials.password)
        console.log("Dentro de login store Ponto 2", credentials.username, credentials.password)
        const token = response.data.access_token
        this.setToken(token)

        console.log("token", token);

        // Decodificar o token JWT para obter as informações do usuário
        const tokenData = JSON.parse(atob(token.split('.')[1]))
        console.log("tokenData.user_type", tokenData.user_type);
        // Atualiza para incluir dados da agência
        this.setUser({
          username: tokenData.sub,
          companyId: tokenData.company_id,
          agencyId: tokenData.agency_id, // Novo campo para agências
          email: tokenData.email,
          userType: tokenData.user_type,
          // Campos adicionais para assinaturas
          subscriptionId: tokenData.subscription_id,
          licenseId: tokenData.license_id
        })

        return true
      } catch (error) {
        console.error('Erro no login:', error)
        this.clearAuth()
        throw error // Propaga o erro para tratamento no componente
      }
    },

    logout() {
      try {
        this.clearAuth()
        return true
      } catch (error) {
        console.error('Erro no logout:', error)
        return false
      }
    },

    async checkAuth() {
      const token = AuthService.getToken()
      if (!token) return false

      try {
        const response = await AuthService.makeRequest({
          url: '/verify-token',
          method: 'GET'
        })

        // Se o token for válido, atualiza as informações do usuário
        if (response.data.user) {
          this.setUser({
            username: response.data.user.sub,
            companyId: response.data.user.company_id,
            agencyId: response.data.user.agency_id, // Novo campo para agências
            email: response.data.user.email,
            userType: response.data.user.user_type,
            // Campos adicionais para assinaturas
            subscriptionId: response.data.user.subscription_id,
            licenseId: response.data.user.license_id
          })
        }

        return true
      } catch (error) {
        this.clearAuth()
        return false
      }
    },

    // Novas funções para verificar status da assinatura/licença
    async checkSubscriptionStatus() {
      if (!this.user || !this.user.subscriptionId) return false;
      
      try {
        const response = await AuthService.makeRequest({
          url: `/subscriptions/${this.user.subscriptionId}/status`,
          method: 'GET'
        });
        
        return response.data;
      } catch (error) {
        console.error('Erro ao verificar status da assinatura:', error);
        return {
          status: 'UNKNOWN',
          isActive: false,
          daysRemaining: 0
        };
      }
    },
    
    async checkLicenseStatus() {
      if (!this.user || !this.user.licenseId) return false;
      
      try {
        const response = await AuthService.makeRequest({
          url: `/licenses/${this.user.licenseId}/status`,
          method: 'GET'
        });
        
        return response.data;
      } catch (error) {
        console.error('Erro ao verificar status da licença:', error);
        return {
          status: 'UNKNOWN',
          isActive: false,
          daysRemaining: 0
        };
      }
    }
  }
})